import filter from 'lodash/filter';
import includes from 'lodash/includes';

export default function filterMessages(seatMessages, seatData) {
  seatMessages = seatMessages || [];
  return filter(seatMessages, function includesSeatTypeId(item) {
    return (
      includes(item.seatTypeIds, seatData.seat_type) ||
      includes(item.holdCodeIds, seatData.hc_no)
    );
  });
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/seats/messagesForSeat.js